<template>
  <div class="login buffer-top">
    <b-container>
      <b-row align-h="center">
        <b-col md="12" class="mt-5">
          <h2>Account Aktivierung </h2>
          <div class="text-center text-primary" v-if="!result">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Aktiviere...</strong>
          </div>
          <b-alert variant="success" :show="result === 'success'">
            Aktivierung Ihres Accounts erfolgreich abgeschlossen. Sie können sich nun einloggen:<br>
            <div class="mt-4"><b-button  variant="primary" @click="() => $router.push('/admin/login')">Zum Login</b-button></div>
          </b-alert>
          <b-alert variant="danger" :show="result === 'failed'">
            <b>Registrieung konnte nicht durchgeführt werden: </b>
            <span v-for="(error, index) in errors" :key="index"
              ><br />{{ error }}</span
            >
          </b-alert>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Auth from '../misc/Auth.js';

export default {
  name: 'Activate',
  data: function () {
    return {
      errors: null,
      result: null,
    }
  },

  props: {
    redirect: String
  },

  mounted() {

    if(!this.$route.params || !this.$route.params.activationToken) {
      this.errors = ['Kein Aktivierungscode übergeben.'];
      this.result = 'failed';
    } else {
      Auth.activate(this.$route.params.activationToken)
        .then((response) => {
          this.result = 'success';
          this.password = '';
        })
        .catch(e => {
          this.result = 'failed';
          if(e.response && e.response.data && Array.isArray(e.response.data)) {
            this.errors = e.response.data.map(err => err.message)
          } 
          else if(e.response && e.response.data) {
            this.errors = [e.response.data.message]
          } else {
            this.errors = ['Unknown error occured']
          }
        })
    }
  }
}

</script>
